var styleDataHash = "715f5383";
const injectCss = (() => {
  var css = `.IjbYa .Color{color:var(--ricos-internal-text-color)}.mzFxk .Color{color:var(--ricos-internal-text-highlight)}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var text_button_color_default = {
  "textColorIcon": "IjbYa",
  "textHighlightIcon": "mzFxk"
};
export {
  text_button_color_default as default,
  injectCss
};
//# sourceMappingURL=text-button-color-scss.js.map
